import React, { useState } from 'react';
import styled from 'styled-components';
import { InputStyled } from '../../../style/components/Input.styled';
import serverStore from '../../../stores/server.store';
import { Link } from 'react-router-dom';
import LoaderComponent from '../Loader.component';
import utilsService from '../../../servises/utils.service';
import uptimeStore from '../../../stores/uptime.store';
import mongodbStore from '../../../stores/mongodb.store';
import { filterMonitorSearchResults } from './headerSearch.utils';

const Styles = styled.div`
  position: relative;

  @media (max-width: 800px) {
    display: none;
  }
`;

const InputWrapperStyled = styled.div`
  input {
    border: 1px solid rgba(72, 77, 91, 0.6);
    height: 32px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    padding: 0 16px;
    outline: none;
    color: rgba(255, 255, 255, 0.88);
    width: 180px;
    font-size: 13px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:focus {
      width: 260px;
      border-color: #36A2EF;
      box-shadow: 0 0 0 3px rgba(54, 162, 239, 0.15);
      background-color: rgba(0, 0, 0, 0.4);
    }
    
    &:hover:not(:focus) {
      border-color: rgba(102, 217, 239, 0.6);
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
`;

const ResultsWrapperStyled = styled.div`
  width: 320px;
  background-color: rgba(29, 30, 36, 0.96);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  position: absolute;
  top: 38px;
  border: 1px solid rgba(72, 77, 91, 0.6);
  border-radius: 8px;
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: rgba(0, 0, 0, 0.45) 0px 8px 32px;
  z-index: 101;

  &.focused_3 {
    max-height: 400px;
    padding: 10px;
    overflow-y: auto;
    
    /* Scrollbar styles for the results dropdown */
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.15);
      border-radius: 3px;
    }
  }
`;

const ResultItemStyled = styled.div`
  margin-bottom: 8px;
  position: relative;
  border-radius: 6px;
  border: 1px solid rgba(72, 77, 91, 0.3);
  background: rgba(255, 255, 255, 0.015);
  transition: all 0.2s ease;
  overflow: hidden;
  padding: 8px 12px 8px 16px;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(102, 217, 239, 0.4);
  }

  a {
    text-decoration: none;
    color: inherit !important;
  }

  &::before {
    content: '';
    width: 4px;
    height: 100%;
    background: #36A2EF;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
  }

  &.no-data::before {
    background: #F3D371;
  }

  &.old-data::before {
    background: #F86B63;
  }
  
  &.paused::before {
    background: rgba(255, 255, 255, 0.4);
  }
`;

const ResultItemLinkWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .name {
    font-weight: 700;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.94);
  }

  .bottom {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    
    label {
      color: rgba(255, 255, 255, 0.45);
      font-size: 10px;
      text-transform: uppercase;
      font-weight: 600;
      margin-bottom: 0;
    }

    span {
      font-size: 11px;
      color: rgba(255, 255, 255, 0.75);
    }
  }
`;

const HeaderSearch = () => {
    const [value, setValue] = useState('');
    const [isOnFocus, setFocus] = useState(false);
    const [isLoader, setLoader] = useState(false);
    const [resultList, setResultList] = useState([]);

    const searchHandle = txt => {
        setValue(txt);

        const monitors = Object.values({
            ...serverStore.serversListObj,
            ...uptimeStore.uptimeListObj,
            ...mongodbStore.mongoDbListObj
        });
        const filteredResults = filterMonitorSearchResults(monitors, txt);
        const tempResults = txt === '' ? filteredResults : filteredResults.reverse();

        setResultList(tempResults);
    };

    const focusHandle = e => {
        setTimeout(() => {
            setFocus(true);
            setResultList(
                Object.values({ ...serverStore.serversListObj, ...uptimeStore.uptimeListObj, ...mongodbStore.mongoDbListObj }));
        }, 300);
    };

    const fcousOutHandle = () => {
        setTimeout(() => {
            setFocus(false);
            setValue('');
            setResultList([]);
        }, 100);
    };

    return (
        <Styles>
            <InputWrapperStyled>
                <InputStyled
                    type="text"
                    value={ value }
                    onChange={ e => searchHandle(e.target.value) }
                    onFocus={ e => focusHandle(e) }
                    onBlur={ e => fcousOutHandle(e) }
                />
            </InputWrapperStyled>


            <ResultsWrapperStyled
                className={ `search-results_dd299 ${ isOnFocus
                    ? 'focused_3'
                    : '' }` }>
                { isLoader && (
                    <LoaderComponent inline />
                ) }
                { resultList.map((res, idx) => {
                    const isUptime = !!res.type;
                    const isMongo = !!res.isMongo;
                    const isServer = !isUptime && !isMongo;

                    let alarmsNumber = 0;
                    if (res.alarms && res.alarms.length) {
                        alarmsNumber = res.alarms.filter(alarm => alarm.status === 1).length;
                    }

                    let classes = '';
                    if (isUptime) {
                        classes = res.classes;
                    } else if (isServer) {
                        classes = res.serverData.classes;
                    } else {
                        classes = res.classes;
                    }

                    let link = '';
                    if (isUptime) {
                        link = `/uptime/${ res._id }`;
                    } else if (isServer) {
                        link = `/servers/${ res._id }`;
                    } else {
                        link = `/mongo/${ res._id }`;
                    }

                    return (
                        <ResultItemStyled
                            className={ classes }
                            key={ idx + '33axz' }
                        >
                            <Link
                                to={ link }
                                className="color-2"
                            >
                                <ResultItemLinkWrapperStyled>
                                    <div className="name">
                                        { res.name }
                                    </div>
                                    <div className="bottom">
                                        { isMongo && (
                                            <>
                                                <div className="item">
                                                    <label>Connections:</label>
                                                    <span>{ res.connections }</span>
                                                </div>
                                            </>
                                        ) }
                                        { isUptime && (
                                            <>
                                                <div className="item">
                                                    <label>Type:</label>
                                                    <span>{ res.type }</span>
                                                </div>
                                                <div className="item">
                                                    <label>Interval:</label>
                                                    <span>{ utilsService.calculateEveryTime(
                                                        res) }</span>
                                                </div>
                                            </>
                                        ) }

                                        { isServer && (
                                            <>
                                                <div className="item">
                                                    <label>OS:</label>
                                                    <span>
                                                { utilsService.getFromMetrics(
                                                    res, 'os_name') }
                                            </span>
                                                </div>
                                                <div className="item">
                                                    <label>IP:</label>
                                                    <span>
                                                { utilsService.getFromMetrics(
                                                    res, 'ipv4') }
                                            </span>
                                                </div>
                                            </>
                                        ) }
                                        <div className="item">
                                            <label>Alarms:</label>
                                            <span>
                                                { alarmsNumber }
                                            </span>
                                        </div>
                                    </div>
                                </ResultItemLinkWrapperStyled>
                            </Link>
                        </ResultItemStyled>
                    );
                }) }
            </ResultsWrapperStyled>

        </Styles>
    );
};

export default HeaderSearch;
